<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-row :gutter="10" style="margin: 1rem 0">
          <CommonExcel ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
          <clear-cache-apply />
        </el-row>
        <el-tab-pane v-for="(item,type) in typeArr" :key="type" :name="type" :label="item">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="list[type]" border style="width: 50%;" height="600">
              <el-table-column label="序号" align="center" width="100">
                <template v-slot:default="{row,$index}">
                  <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="名称" align="center">
                <template v-slot:default="{row}">
                  <el-input v-model="row.name" style="width: 250px;" placeholder="名称" />
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template v-slot:default="{row,$index}">
                  <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                  <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  <el-button type="success" size="mini" @click="handleCopy(row)">拷贝</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div style="float:left;margin-top: 1rem">
              <el-button type="primary" size="mini" @click="handleAdd(type,'新增配置',[])">新增</el-button>
              <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
            </div>
          </el-card>
        </el-tab-pane>
      </el-tabs>
      <el-dialog :show-close="false" :before-close="handleClose" title="提示" :visible.sync="dialog" width="60%">
        <el-table :key="tableKey" size="mini" :data="diaLogList" border fit highlight-current-row style="width: 100%;" height="500">
          <template v-if="type==1">
            <el-table-column prop="percent" header-align="center" label="上一期完成度(%)">
              <template v-slot:default="scope">
                <el-input-number v-model.number="scope.row.lastTimesMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="上一期完成度" />
                -
                <el-input-number v-model.number="scope.row.lastTimesMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="上一期完成度" />
              </template>
            </el-table-column>
            <el-table-column prop="percent" header-align="center" label="干涉层级(%)">
              <template v-slot:default="scope">
                <el-input-number v-model.number="scope.row.controlMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                -
                <el-input-number v-model.number="scope.row.controlMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
              </template>
            </el-table-column>
            <el-table-column prop="percent" header-align="center" label="进度参数(%)">
              <template v-slot:default="scope">
                <el-input-number v-model.number="scope.row.progressMin" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
                -
                <el-input-number v-model.number="scope.row.progressMax" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="干涉层级" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==2">
            <el-table-column prop="percent" header-align="center" label="倍率">
              <template v-slot:default="scope">
                <el-input-number v-model.number="scope.row.bet" :controls="false" :min="0" style="width: 47%" placeholder="倍率" />
              </template>
            </el-table-column>
            <el-table-column prop="percent" header-align="center" label="系数">
              <template v-slot:default="scope">
                <el-input-number v-model.number="scope.row.ce" :controls="false" :min="0" :max="100" style="width: 47%" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template v-slot:default="{row,$index}">
                <el-button style="margin-left: .5rem;display:block;" size="mini" type="danger" @click="deleteRewardDialogList($index)">删除</el-button>
              </template>
            </el-table-column>
          </template>
          <template v-if="type==3">
            <el-table-column label="阶段">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stage" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column label="进度1">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.progress1" placeholder="进度" />
              </template>
            </el-table-column>
            <el-table-column label="系数1">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.coefficient1" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column label="进度2">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.progress2" placeholder="进度" />
              </template>
            </el-table-column>
            <el-table-column label="系数2">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.coefficient2" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column label="进度3">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.progress3" placeholder="进度" />
              </template>
            </el-table-column>
            <el-table-column label="系数3">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.coefficient3" placeholder="系数" />
              </template>
            </el-table-column>
            <el-table-column label="进度4">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.progress4" placeholder="进度" />
              </template>
            </el-table-column>
            <el-table-column label="系数4">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.coefficient3" placeholder="系数" />
              </template>
            </el-table-column>
          </template>
          <template v-if="type==4">
            <el-table-column prop="stage" label="开启阶段">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stage" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column prop="ts" label="时间(分钟)">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.ts" placeholder="时间" />
              </template>
            </el-table-column>
            <el-table-column prop="percent" label="进度百分比">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.minPercent" style="width: 47%" placeholder="进度最低百分比" />
                -
                <el-input v-model.number="scope.row.maxPercent" style="width: 47%" placeholder="进度最大百分比" />
              </template>
            </el-table-column>
            <el-table-column prop="coefficient" label="系数">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.coefficient" placeholder="系数" />
              </template>
            </el-table-column>
          </template>
          <template v-if="type==6">
            <el-table-column prop="stage" label="每天触发次数">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.dayLimit" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column prop="ts" label="触发间隔时长(分)">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.intervalTime" placeholder="时间" />
              </template>
            </el-table-column>
            <el-table-column prop="percent" label="进度百分比">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.minPercent" style="width: 47%" placeholder="进度最低百分比" />
                -
                <el-input v-model.number="scope.row.maxPercent" style="width: 47%" placeholder="进度最大百分比" />
              </template>
            </el-table-column>
            <el-table-column prop="coefficient" label="系数">
              <template v-slot:default="scope">
                <el-input v-model.trim="scope.row.coefficient" placeholder="系数" />
              </template>
            </el-table-column>
          </template>
          <template v-if="type==5">
            <el-table-column prop="stage" label="阶段">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stage" placeholder="阶段" />
              </template>
            </el-table-column>
            <el-table-column prop="stepnum" label="步骤进度">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stepnum" placeholder="步骤进度" />
              </template>
            </el-table-column>
            <el-table-column prop="progressBarId" label="进度Bar">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.progressBarId" placeholder="进度Bar" />
              </template>
            </el-table-column>
            <el-table-column prop="stageSpins" label="最低消耗体力">
              <template v-slot:default="scope">
                <el-input v-model.number="scope.row.stageSpins" placeholder="最低消耗体力" />
              </template>
            </el-table-column>
            <el-table-column label="常规奖励">
              <template v-slot:default="scope">
                <Reward :value="scope.row.prize" />
              </template>
            </el-table-column>
            <el-table-column label="限时奖励">
              <template v-slot:default="scope">
                <Reward :value="scope.row.limitPrize" />
              </template>
            </el-table-column>
            <el-table-column label="超级加赠奖励">
              <template v-slot:default="scope">
                <Reward :value="scope.row.superPrize" />
              </template>
            </el-table-column>
          </template>
        </el-table>
        <span slot="footer" class="dialog-footer" style="margin-right: 10px"><el-button size="small" type="primary" @click="addRewardDialogList">新增</el-button></span>
        <span slot="footer" class="dialog-footer"><el-button size="small" @click="dialog = false">关 闭</el-button></span>
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { actAuxiliary, actionActAuxiliary, delActAuxiliary } from '@/api/config/activity-auxiliary-cfg'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { handleImportPrize } from '@/utils'

export default {
  name: 'SuperCollect',
  components: { ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      tableKey: 0,
      stageCoefficientHeader: ['阶段', '进度1', '系数1', '进度2', '系数2', '进度3', '系数3', '进度4', '系数4'],
      loading: false,
      dialog: false,
      diaLogList: [],
      list: [],
      type: 1,
      typeArr: { 1: '调控系数', 2: '高倍率调控系数', 3: '修正系数', 4: '超级加赠', 6: '个人加赠', 5: '奖励配置' },
      curClass: 'super_collect'
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getList()
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    },
    openDialog(config) {
      this.tableKey++
      this.diaLogList = config
      this.dialog = true
    },
    handleTabClick(val) {
      this.type = Number(val.name)
      this.diaLogList = []
    },
    getList() {
      this.loading = true
      actAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      this.$confirm('确认要删除吗?', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (id !== 0) {
          delActAuxiliary({ idList: [id] })
        }
        this.list[this.type].splice(index, 1)
      })
    },
    handleCopy(row) {
      const _row = Object.assign({}, row)
      _row.id = 0
      this.list[this.type].push(_row)
    },
    handleAdd(type, name, config) {
      this.list[type].push({ id: 0, name: name, class: this.curClass, type: type, config: config })
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        for (let j = 0; j < this.list[this.type].length; j++) {
          if (this.list[this.type][j].name === sheet) {
            this.list[this.type][j].config = handleImportPrize(excelData[i].sheetData)
            editFlag = true
          }
        }
        if (!editFlag) {
          this.handleAdd(this.type, sheet, handleImportPrize(excelData[i].sheetData))
        }
      }
    },
    handleSaveConfig(type) {
      actionActAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      for (let i = 0; i < this.list[this.type].length; i++) {
        nameArr.push(this.list[this.type][i].name)
        dataArr.push(this.list[this.type][i].config)
      }
      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      fileName = this.typeArr[type]
      let tranTitle = {}

      switch (this.type) {
        case 1:
          tranTitle = {
            lastTimesMin: '上一期完成度(%)-最小值',
            lastTimesMax: '上一期完成度(%)-最大值',
            controlMin: '干涉层级(%)-最小值',
            controlMax: '干涉层级(%)-最大值',
            progressMin: '进度参数(%)-最小值',
            progressMax: '进度参数(%)-最大值'
          }
          break
        case 2:
          tranTitle = {
            bet: '倍率',
            ce: '系数'
          }
          break
        case 3:
          tranTitle = {
            stage: '阶段',
            progress1: '进度1',
            coefficient1: '系数1',
            progress2: '进度2',
            coefficient2: '系数2',
            progress3: '进度3',
            coefficient3: '系数3',
            progress4: '进度4',
            coefficient4: '系数4'
          }
          break

        case 4:
          tranTitle = {
            stage: '阶段',
            ts: '时间(分钟)',
            minPercent: '进度百分比-最小值',
            maxPercent: '进度百分比-最大值',
            coefficient: '系数'
          }
          break
        case 5:
          tranTitle = {
            stage: '阶段',
            stepnum: '步骤进度',
            progressBarId: '进度Bar',
            stageSpins: '最低消耗体力',
            prize: { name: '奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }},
            limitPrize: { name: '限时奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }},
            superPrize: { name: '超级加赠奖励', sub: { propsId: '道具', num: '数量', rtype: '取值类型', skin: '皮肤' }}
          }
          break

        case 6:
          tranTitle = {
            dayLimit: '每天触发次数',
            intervalTime: '触发间隔时长(分)',
            minPercent: '进度最低百分比',
            maxPercent: '进度最大百分比',
            coefficient: '系数'
          }
          break
      }

      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], tranTitle)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }
      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addRewardDialogList(index) {
      switch (this.type) {
        case 1:
          this.diaLogList.push({
            lastTimesMin: 0,
            lastTimesMax: 0,
            controlMin: 0,
            controlMax: 0,
            progressMin: 0,
            progressMax: 0
          })
          break
        case 2:
          this.diaLogList.push({ bet: 0, ce: 0 })
          break
        case 3:
          this.diaLogList.push({
            stage: 1,
            progress1: 0,
            coefficient1: 0,
            progress2: 0,
            coefficient2: 0,
            progress3: 0,
            coefficient3: 0,
            progress4: 0,
            coefficient4: 0
          })
          break
        case 4:
          this.diaLogList.push({
            stage: 1,
            ts: 0,
            minPercent: 0,
            maxPercent: 0,
            coefficient: 0
          })
          break
        case 5:
          this.diaLogList.push({
            stage: 1,
            stepnum: 0,
            progressBarId: 0,
            stageSpins: 0,
            prize: [],
            limitPrize: [],
            superPrize: []
          })
          break
        case 6:
          this.diaLogList.push({
            dayLimit: 1,
            intervalTime: 0,
            minPercent: 0,
            maxPercent: 0,
            coefficient: 0
          })
          break
      }
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    }
  }
}
</script>

